import CheckIcon from '@mui/icons-material/Check';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React, { ChangeEvent, useState } from 'react';
import ContentField from './ContentField';

export default function DialogFormResponseField(props: {values: any; classes: any;setFieldValue: any;}) {
  const {values, classes, setFieldValue } = props;
  const [newResponse, setNewResponse] = useState('');
  const questionResponses = Object.keys(values.responses ? values.responses : {});
  return (
    <Grid container direction="column">
      <Typography variant="body2" style={{marginBottom: 12}}>Responses ({questionResponses.length}):</Typography>
      {questionResponses.length > 0 && <Grid item style={{padding: '0 24px'}}>
        <ul style={{marginBottom: 12,}}>
          {questionResponses.map((response: string) => <li style={{color: '#2e2e2e'}} key={response}>{response}</li>)}
        </ul>
      </Grid>}
      <ContentField
        name={`question-${questionResponses.length - 1}`}
        id={`question-${questionResponses.length - 1}`}
        value={newResponse}
        onChange={(event: ChangeEvent<HTMLInputElement>) => {
          setNewResponse(event.target.value)
        }}
        sx={classes.input}
        variant="outlined"
        label={`New Response`}
        multiline
        validation={{}}
        touched={true}
        InputProps={
          {
            notched: true,
            additionalEndAdornments: <IconButton
              size="small"
              color="primary"
              onClick={() => {
                const _responses = {...values.responses}
                // remove periods to prevent objectSet error
                _responses[newResponse.replace(/\./g,'')] = {
                  body: '',
                  responses: {}
                }
                setFieldValue('responses', _responses);
                setNewResponse('');
              }}
            >
              <CheckIcon/>
            </IconButton>
          }
        }
      />
    </Grid>
  );
}
